export default "__VITE_ASSET__DHxNyy59__"